import { createApp } from 'vue'
import App from '@/App'
import router from '@/router';
import '@/style/style.css';

createApp(App).use(router).mount('#app');
